import axios from "./AxiosClient";
import { Constants } from "@socialcoach/services";
import { VideoScript, VideoScriptSearchQuery, Page } from "./dtos";
import { scCatchServiceException } from "@/annotations";

const VIDEO_SCRIPT_SERVICE = `${Constants.API_URL}/bedrock/video_scripts`;
const VIDEO_SCRIPT_EXCLUSION_SERVICE = `${Constants.API_URL}/bedrock/video_script_category_exclusions`;

export class VideoScriptsServices {
  @scCatchServiceException()
  static async search(query: VideoScriptSearchQuery, options?: { signal?: AbortSignal }): Promise<Page<VideoScript>> {
    const { data } = await axios.post(`${VIDEO_SCRIPT_SERVICE}/search`, query, options);
    return data;
  }

  @scCatchServiceException()
  static async getExcludedCategoryIds(): Promise<number[]> {
    const { data } = await axios.get(`${VIDEO_SCRIPT_EXCLUSION_SERVICE}`);
    return data.category_ids || [];
  }

  @scCatchServiceException()
  static async setExcludedCategoryIds(categoryIds: number[]): Promise<number[]> {
    const { data } = await axios.patch(`${VIDEO_SCRIPT_EXCLUSION_SERVICE}`, { categoryIds });
    return data;
  }
}
